// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateSnapshotBar_container__it3qU","loadingContainer":"CreateSnapshotBar_loadingContainer__3a3h1"};